import { PdfHeader } from '../pdfHeader';
import { PdfFooter } from '../pdfFooter';
import { PdfTable } from '../infoPage/table';
import { InfoTitle } from '../infoPage/title';
import { Statistics } from '../infoPage/statistics';
import { Page, Text, View } from '@react-pdf/renderer';
import { PortCoPageProps } from 'interfaces/components/dashboardPdf';

export const FirstPage = ({
  data,
  columns,
  pagesCount,
  companyName,
  companyInfo
}: PortCoPageProps) => {
  return (
    <Page
      size='A4'
      orientation='landscape'
      style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
    >
      <PdfHeader />

      <View
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '6px',
          paddingHorizontal: '20px'
        }}
      >
        <Text
          style={{ fontSize: '16px', fontWeight: 'semibold', color: '#151515' }}
        >
          ICONIQ Enterprise Five
        </Text>

        <Text
          style={{ fontSize: '10px', fontWeight: 'light', color: '#5C5C5C' }}
        >
          The ICONIQ Enterprise Five can help you determine the health of your
          business. Startups often include these metrics in regular reporting to
          understand the drivers of revenue and profit performance and support
          strategic planning decisions on everything from GTM strategy to team
          size.
        </Text>

        <Text
          style={{ fontSize: '10px', fontWeight: 'light', color: '#5C5C5C' }}
        >
          The numbers, figures, and case studies presented here are
          illustrative, and there is no guarantee that the actual results
          achieved by any ICONIQ portfolio or partners or affiliates will match
          those in the tool. Past performance is not a guide to future
          performance, and any investment may result in the loss of all or part
          of the money invested.
        </Text>
      </View>

      <Statistics companyInfo={companyInfo} />

      <View
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          paddingHorizontal: '20px'
        }}
      >
        <InfoTitle
          name={companyName}
          status={companyInfo.requiredInfo.status || ''}
          website={companyInfo.companyDetails.companyWebsite}
        />

        <Text
          style={{ fontSize: '10px', fontWeight: 'light', color: '#5C5C5C' }}
        >
          Below, you'll find the user parameters you provided, along with
          corresponding graphs that visualize these comparisons.
        </Text>
      </View>

      <PdfTable
        columns={columns}
        data={data.slice(0, 12)}
        title='KEY FINANCIALS SECTION'
      />

      <PdfFooter pageNumber={1} pagesCount={pagesCount} />
    </Page>
  );
};
